module.exports = __webpack_public_path__ + "media/giftcards/Card-77967dc2.png";